/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_TableInputs */

const en_download_table = /** @type {(inputs: Download_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download table`)
};

const nl_download_table = /** @type {(inputs: Download_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download tabel`)
};

/**
* | output |
* | --- |
* | "Download table" |
*
* @param {Download_TableInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const download_table = /** @type {((inputs?: Download_TableInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_TableInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_download_table(inputs)
	return en_download_table(inputs)
});